<form class="form w-full" (ngSubmit)="submit()">
  <div class="text-center mb-6">
    <p class="mfa-copy">
      {{ "AUTH.LOGIN.MFA_MESSAGE" | translate }} {{ email }}
    </p>
  </div>

  @if (hasError) {
  <div class="mb-5">
    <div class="font-bold text-red-400">
      {{ "AUTH.LOGIN.MFA_INVALID_CODE" | translate }}
    </div>
  </div>
  }

  <div class="flex flex-col mb-6">
    <label class="form-label font-bold text-black mb-1">
      {{ "AUTH.LOGIN.MFA_CODE" | translate }}
    </label>
    <div class="mfa-code-group" [ngClass]="{ 'is-invalid': hasError }">
      @for (index of codeIndexes; track index) {
      <input
        #codeInput
        class="mfa-code-box"
        type="text"
        inputmode="numeric"
        autocomplete="one-time-code"
        maxlength="1"
        [attr.aria-label]="'Digit ' + (index + 1)"
        [value]="codeDigits[index]"
        (input)="onDigitInput($event, index)"
        (keydown)="onDigitKeydown($event, index)"
        (paste)="onDigitPaste($event, index)"
      />
      }
    </div>
  </div>

  <div class="mb-4 w-full">
    <button
      pButton
      type="button"
      class="w-full"
      [disabled]="codeValue().length !== 6 || isLoading"
      (click)="submit()"
    >
      @if (isLoading) {
      <span class="indicator-progress" [style.display]="'block'">
        {{ "AUTH.LOGIN.PLEASE_WAIT" | translate }}
        <span class="spinner-border spinner-border-sm align-middle ml-2"></span>
      </span>
      } @else {
      <span class="indicator-label">
        {{ "AUTH.LOGIN.MFA_VERIFY" | translate }}
      </span>
      }
    </button>
  </div>

  <div class="mfa-actions">
    <button
      pButton
      type="button"
      severity="secondary"
      text
      [disabled]="resendSecondsLeft() > 0 || isLoading"
      (click)="resendCode()"
    >
      @if (resendSecondsLeft() > 0) {
      {{ "AUTH.LOGIN.MFA_RESEND_IN" | translate }} {{ resendSecondsLeft() }}s
      } @else {
      {{ "AUTH.LOGIN.MFA_RESEND" | translate }}
      }
    </button>

    <button pButton type="button" text severity="secondary" (click)="back.emit()">
      {{ "AUTH.LOGIN.MFA_BACK" | translate }}
    </button>
  </div>
</form>
